// ============================================================================
// Textos por MÓDULO (oct-2026).
//
// Cada módulo trae sus propios textos en src/i18n/modulos/<modulo>.ts, en
// español y en inglés. Así los textos viajan en el mismo chunk que el módulo
// (no inflan la carga inicial) y un módulo se puede sacar a otro proyecto con
// sus traducciones.
//
//   // src/i18n/modulos/inventario.ts
//   import { defineTextos } from '../textos.ts';
//   export const textosInventario = defineTextos({
//     titulo: 'Inventario',
//     bajoMinimo: '{n} items bajo el mínimo',
//   }, {
//     titulo: 'Inventory',
//     bajoMinimo: '{n} items below minimum',
//   });
//
//   // En el componente:
//   const t = useTextos(textosInventario);        // hook (regional-context)
//   t('bajoMinimo', { n: 3 })
//   // Fuera de un componente (helper llamado en el render):
//   textoDe(textosInventario, 'titulo')
//
// El typecheck exige que el inglés tenga TODAS las claves del español.
// ============================================================================
import { interpolar, type VarsTraduccion } from './traducir.ts';
import { getIdiomaActual } from './actual.ts';

export interface Textos<K extends string> {
  es: Record<K, string>;
  en: Record<K, string>;
  /** Idiomas futuros (fr, pt…): pueden ser parciales; lo que falte cae a español. */
  [idioma: string]: Partial<Record<K, string>> | undefined;
}

export function defineTextos<E extends Record<string, string>>(
  es: E,
  en: Record<keyof E, string>,
  otros: Record<string, Partial<Record<keyof E, string>>> = {},
): Textos<keyof E & string> {
  return { ...otros, es, en } as Textos<keyof E & string>;
}

export function textoDe<K extends string>(
  m: Textos<K>,
  clave: K,
  vars?: VarsTraduccion,
  idioma: string = getIdiomaActual(),
): string {
  const dic = (m as unknown as Record<string, Record<K, string> | undefined>)[idioma];
  return interpolar(dic?.[clave] ?? m.es[clave] ?? clave, vars);
}
